import React, { useEffect, useState } from "react";

const Toast = ({ message, flag = "success", duration = 3000, onClose }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            onClose(); // Call parent function to remove toast
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    // Styles for different toast types
    const toastStyles = {
        success: { background: "#28a745", color: "white" },
        error: { background: "#dc3545", color: "white" },
        warning: { background: "#ffc107", color: "black" },
    };

    if (!visible) return null;

    return (
        <div style={{
            position: "fixed",
            top: "60px",
            right: "20px",
            padding: "15px 20px",
            borderRadius: "5px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            ...toastStyles[flag],
        }}>
            {message}
        </div>
    );
};

export default Toast;
